import * as echarts from 'echarts/lib/echarts.js';

export default class ChartService {

  defaultChartOptions = {
    backgroundColor: '#fff',
    color: [
      '#4ec1ef',
      '#60e9b3',
      '#ffc65e',
      '#276c98',
      '#37ae8c',
      '#ed8a1a',
      '#002344',
    ],
    textStyle: {
      fontFamily: 'Source Sans Pro, sans-serif',
    },
    tooltip: {
      backgroundColor: 'rgb(45, 45, 45)',
      confine: true,
      extraCssText: `
        border-radius: 3px;
        box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.3);
      `,
      padding: 12,
      textStyle: {
        color: 'white'
      },
    },
  };

  // abstract buildChartData(visualization: any, isEditMode: boolean, bndBox: any): echarts.EChartOption;

  render(container, chartOptions) {
    const chart = echarts.init(container);
    if (chartOptions.forceRedraw) {
      chart.clear();
    }
    chart.setOption(chartOptions, true);
    return chart;
  }

}
